(()=>{
function initGallery(gallery){
if(gallery.dataset.bound)return;
gallery.dataset.bound='true';
const slides=[...gallery.querySelectorAll('[data-gallery-slide]')],dots=[...gallery.querySelectorAll('[data-gallery-to]')],count=gallery.querySelector('[data-gallery-count]');
if(!slides.length)return;
let current=Math.max(0,slides.findIndex(slide=>!slide.hidden));
function show(index){
current=(index%slides.length+slides.length)%slides.length;
slides.forEach((slide,i)=>{slide.hidden=i!==current;slide.classList.toggle('is-active',i===current);slide.setAttribute('aria-hidden',String(i!==current))});
dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===current);dot.setAttribute('aria-current',String(i===current))});
if(count)count.textContent=`${current+1} / ${slides.length}`
}
gallery.showMediaId=id=>{const index=slides.findIndex(slide=>slide.dataset.mediaId===id);if(index>=0)show(index)};
gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(current-1));
gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(current+1));
dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));
let startX=0,startY=0;
gallery.addEventListener('touchstart',event=>{const touch=event.changedTouches[0];startX=touch.clientX;startY=touch.clientY},{passive:true});
gallery.addEventListener('touchend',event=>{const touch=event.changedTouches[0],dx=touch.clientX-startX,dy=touch.clientY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1))},{passive:true});
}
function init(){
document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
document.querySelectorAll('[data-variant-select]').forEach(select=>{
if(select.dataset.bound)return;
select.dataset.bound='true';
select.addEventListener('change',()=>{
const option=select.selectedOptions[0],info=select.closest('.product-information'),button=info.querySelector('[data-add-button]');
info.querySelector('[data-product-price]').textContent=option.dataset.price;
button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to bag ↗';
const quantity=info.querySelector('[name=quantity]');quantity.min=option.dataset.min;quantity.step=option.dataset.step;if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=option.dataset.min;
const gallery=select.closest('.product-page')?.querySelector('[data-product-gallery]');if(option.dataset.featuredMediaId)gallery?.showMediaId?.(option.dataset.featuredMediaId);
const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url)
})
})
}
init();document.addEventListener('shopify:section:load',init)
})();